import { event } from '@rategravity/frontend/modules/user-actions';
import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import { HatIcon } from '../../shared/icons';

const style = {
  closed: {
    display: 'none'
  },
  container: {
    width: '90%',
    margin: '0 auto'
  },
  title: {
    color: colors.secondary,
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1em'
  },
  infoTitle: {
    cursor: 'pointer'
  },
  infoIcon: {
    fill: colors.secondary,
    margin: '0 .25em 0 0',
    height: 24,
    cursor: 'pointer'
  },
  infoCopy: {
    marginTop: 0,
    marginBottom: '1em'
  }
};

export const InfoCopy = (props) => <p style={style.infoCopy}>{props.children}</p>;

export const InfoList = (props) => <ul style={style.infoCopy}>{props.children}</ul>;

export class InfoLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.setState({ open: !this.state.open });
    const baseMsg = 'Clicked Info Drop Down';
    this.props.actionPipe.next(
      event(baseMsg, {
        title: this.props.title
      })
    );
  }
  render() {
    return (
      <div>
        <div style={style.title} onClick={this.handleClick}>
          <HatIcon style={style.infoIcon} />
          <h6 style={style.infoTitle}>{this.props.title}</h6>
        </div>
        <div style={this.state.open ? null : style.closed}>
          <div style={style.container}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/info-link/index.js